import JakiEffect from "effects/midi/jaki/JakiEffect.js";
import JGraphics from '../../custom/JGraphics.js';
import MidiTrigger from "effects/midi/MidiTrigger.js";
import {doc} from '../docs.js';
import {BANG, TIDALS, FIGURES, RULES, PARAMS, TRIGGER, TICK, STOP, START} from "messaging/message-types.js";
import StepData from 'pattern/StepData.js';
import JakiParams from "effects/midi/jaki/JakiParams.js";
import Figures from "effects/midi/jaki/Figures.js";
import RulesRack from "effects/midi/jaki/RulesRack.js";

doc(
    "jaki",
    {
    },
    "Generative drums",
    ["trigger-routing"],
    {
        inlets: [PARAMS, RULES, FIGURES],
        tags: "Rhythm",
        connects: [
            {
                outlet: TIDALS,
                object: "jgraphics",
                inlet: TIDALS
            },
            {
                outlet: "trigger-routing",
                object: "pad",
                inlet: "trigger-routing"
            }
            ]
    }
);

export const jaki = (object, ...figures) => {
    // tell the sequencer to give it a tick
    let stepData = new StepData();
    stepData.loadDefaults();
    stepData.velocity = 0.5;
    stepData.duration = 1000000;
    object.needsTick = true;

    // instantiate a Jaki Effect passin gin the node
    let effect = new JakiEffect(object.subSequence, object);
    object.effect = effect;

    return ([type, ...args]) => {
        switch (type) {
        case TICK:
            let [stepNumber, time] = args;
            effect.onNewStep(stepNumber, time);
            if (stepNumber === 0) {
                // get a new step of infinite duration and
                // send thru the jaki effect
                let trigger = new MidiTrigger(
                    stepData, time, stepNumber);
                effect.input(trigger);
            }

            let triggers = effect.output(time, stepNumber, stepNumber);
            return [[TRIGGER, triggers]];
            break;
        case STOP:
            effect.stop();
            break;
        case START:
            effect.clear();
            break;
        case PARAMS:
            effect.jakiParams = args[0];
            break;
        case RULES:
            let rules = args[0];
            if (Array.isArray(rules[0])) {
                rules.forEach(
                    (arg, i) => effect.rules[i].rules = arg);
            } else {
                effect.rules[0].rules = rules;
            }
            break;
        case FIGURES:
            effect.figures = args[0];
            break;
        }
    };
};

doc(
    "jparams",
    {
    },
    "Parameters for Jaki Object",
    undefined,
    {
        tags: "Rhythm",
        inlets: [],
        outlets: ["params"],
        connects: {
            object: "jaki",
            inlet: "params"
        }
    }
);

export const jparams = (object) => {
    let jakiParams = new JakiParams(object.subSequence, object);
    object.effect = jakiParams;
    object.needsStart = true;

    return ([type]) => {
        // send the rules out the 1st outlet
        return jakiParams;
    };
};

doc(
    "jrules",
    {
    },
    "Rules for Jaki Object",
    x => 0,
    {
        //tags: "Rhythm",
        /*
        connects: {
            object: "jaki",
            inlet: "rules"
        }
        */
    }
);

export const jrules = (object) => {
    let rules = new RulesRack(object.subSequence, object);
    object.width = 340;
    object.height= 240;
    rules.width = 340;
    rules.height = 240;
    object.effect = rules;
    object.needsStart = true;

    return ([type]) => {
        rules.publishRules();
        return;
    };
};

doc(
    "jfigures",
    {
    },
    "Figures for Jaki Object",
    ["figures"],
    {
        tags: "Rhythm",
        connects: {
            object: "jaki",
            inlet: "figures"
        }
    }
);

export const jfigures = (object) => {
    let figures = new Figures(object.subSequence, object);
    object.effect = figures;
    object.needsLoad = true;

    return ([type]) => {
        // send the rules out the 1st outlet
        return figures
    };
};


doc(
    "jgraphics",
    {
    },
    "Draws graphics for a Jaki object",
    undefined,
    {
        tags: "Rhythm",
        inlets: [TIDALS],
    }
);

export const jgraphics = (object) => {
    let jgraph = new JGraphics(object);
    object.effect = jgraph;
    
    return ([type, tidals]) => {
        // send the rules out the 1st outlet
        switch (type) {
        case TIDALS:
            jgraph.tidals = tidals;
        }
        return undefined;
    };
};

export const jwhen = (object, type, action) => {
    return () => {
        let _type = type();
        let _action = action();

    };
};

export const jaki_objects = {
    jaki,
    jparams,
    jrules,
    jfigures,
    jgraphics
};



